import React, { useState } from 'react';
import { ReactComponent as RightArrowIcon } from '../../assets/icons/rightarrow.svg';
import ramaLogo from '../../assets/plus_icon/rama_logo.png'
import { ReactComponent as LogoIcon } from '../../assets/logo.svg';
import SVWelcomeImage from '../../assets/plus_icon/sv_welcome.png'
import SVWelcomeMobile from '../../assets/plus_icon/mobile_welcome.png';
import SVWelcomeDesktop from '../../assets/plus_icon/desktop_welcom.png'
const WelcomePage = ({ setChannelPartner, branding, loadingConfig, activeVisitsCount, onOpenActiveVisitsModal }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);

    const handleLogout = () => {
        localStorage.clear();
        window.location.reload();
        console.log("Hi");
        console.log("Welcome page Load");
    };

    const name = localStorage.getItem('name') || '';
    const mobile = localStorage.getItem('mobile') || '';

    const showSkeleton = loadingConfig || (branding?.banners && !imageLoaded);

    const handleImageLoad = () => {
        setImageLoaded(true);
    };

    const getInitials = (fullName) => {
        if (!fullName) return 'U';
        const parts = fullName.trim().split(' ').filter(Boolean);
        if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    };

    return (
        <>
            {showSkeleton && (
                <div className="w-full flex flex-col justify-between animate-pulse">
                    {/* Banner Skeleton */}
                    <div className="w-full bg-gray-200 h-[250px] sm:h-[400px] xl:h-[500px] rounded-xl"></div>
                    
                    {/* Logo and Partner Area Skeleton */}
                    <div className="flex items-center justify-center !my-5 sm:!mb-10 sm:mt-8">
                        <div className="bg-gray-200 h-[80px] sm:h-[90px] w-[228px] rounded-lg"></div>
                        <div className="border-r-2 border-gray-200 h-[80px] sm:h-[100px] !ml-7 !mr-12"></div>
                        <div className="bg-gray-200 sm:w-[200px] sm:h-[90px] w-[130px] h-[62px] rounded-lg"></div>
                    </div>

                    {/* Banner Image Skeleton */}
                    <div className="w-full bg-gray-200 h-[200px] sm:h-[300px] rounded-xl"></div>

                    {/* Button Area Skeleton */}
                    <div className="flex items-center justify-center w-full absolute left-0 bottom-6">
                        <div className="bg-gray-200 h-11 sm:h-16 w-[95%] sm:w-[396px] rounded-xl"></div>
                    </div>
                </div>
            )}

            <div style={{ display: showSkeleton ? 'none' : 'block' }}>
                {/* Profile Container */}
                <div className='absolute z-10' style={{ top: activeVisitsCount > 0 ? '75px' : '50px', right: '50px' }}>
                    <div className="relative">
                        <button
                            onClick={() => setDropdownOpen(!dropdownOpen)}
                            className='w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-[#EBF3FF] text-[#3B82F6] font-bold text-xs sm:text-sm shadow-md border border-[#D0E2FF] flex items-center justify-center hover:bg-blue-100 focus:outline-none transition-all'
                        >
                            {name ? getInitials(name) : (
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#4B5563" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                                    <circle cx="12" cy="7" r="4" />
                                </svg>
                            )}
                        </button>

                        {dropdownOpen && (
                            <>
                                {/* Invisible overlay to close dropdown on click outside */}
                                <div 
                                    className="fixed inset-0 z-40 bg-transparent" 
                                    onClick={() => setDropdownOpen(false)}
                                />
                                {/* Dropdown Menu */}
                                <div className='absolute right-0 top-full mt-2 w-60 bg-white border border-gray-200 rounded-xl shadow-lg py-1.5 z-50 animate-in fade-in slide-in-from-top-2 duration-100'>
                                    {(name || mobile) && (
                                        <div className="px-3.5 py-2.5 border-b border-gray-100 flex items-center gap-3" style={{ pointerEvents: 'none' }}>
                                            <div className="w-9 h-9 rounded-full bg-[#EBF3FF] text-[#3B82F6] font-bold text-xs flex items-center justify-center flex-shrink-0 shadow-xs border border-[#D0E2FF]">
                                                {getInitials(name)}
                                            </div>
                                            <div>
                                                {name && <p className="font-bold text-gray-900 mb-0 text-sm leading-tight">{name}</p>}
                                                {mobile && <p className="text-gray-500 mb-0 text-xs mt-0.5 font-medium">{mobile}</p>}
                                            </div>
                                        </div>
                                    )}
                                    <button
                                        onClick={handleLogout}
                                        className='w-full px-4 py-2.5 text-left text-sm text-red-600 hover:bg-red-50 flex items-center gap-2.5 font-medium transition-colors border-0 bg-transparent'
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                            <polyline points="16 17 21 12 16 7" />
                                            <line x1="21" y1="12" x2="9" y2="12" />
                                        </svg>
                                        Logout
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                {/* Running Visits Top Strip (Red when > 0, Blue when 0) */}
                <div
                    onClick={onOpenActiveVisitsModal}
                    className={`w-full px-4 py-2.5 sm:px-5 sm:py-3 cursor-pointer transition-colors flex items-center justify-between border-l-[4px] ${
                        activeVisitsCount > 0
                            ? 'bg-[#FEF2F2] border-[#EF4444] hover:bg-red-100/70'
                            : 'bg-[#EEF2FF] border-[#635BFF] hover:bg-indigo-100/70'
                    }`}
                >
                    <div className="flex items-center gap-3">
                        <div className={`w-8 h-8 sm:w-9 sm:h-9 rounded-full text-white flex items-center justify-center flex-shrink-0 shadow-sm ${
                            activeVisitsCount > 0 ? 'bg-[#EF4444]' : 'bg-[#635BFF]'
                        }`}>
                            {activeVisitsCount > 0 ? (
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="12" cy="12" r="10" />
                                    <polyline points="12 6 12 12 16 14" />
                                </svg>
                            ) : (
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="20 6 9 17 4 12" />
                                </svg>
                            )}
                        </div>
                        <div>
                            <h4 className="text-xs sm:text-sm font-bold text-gray-900 mb-0 leading-snug">
                                {activeVisitsCount > 0
                                    ? `${activeVisitsCount} running site ${activeVisitsCount === 1 ? 'visit needs' : 'visits need'} an out-time`
                                    : 'No running site visits'}
                            </h4>
                            <p className="text-[11px] sm:text-xs text-gray-500 font-medium mb-0 mt-0.5">
                                {activeVisitsCount > 0
                                    ? 'Tap to close out visits before starting a new check-in'
                                    : 'All site visits have out-times recorded'}
                            </p>
                        </div>
                    </div>

                    <div className="flex items-center gap-2">
                        <span className={`w-6 h-6 rounded-full text-white text-xs font-bold flex items-center justify-center flex-shrink-0 ${
                            activeVisitsCount > 0 ? 'bg-[#EF4444]' : 'bg-[#635BFF]'
                        }`}>
                            {activeVisitsCount ?? 0}
                        </span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={activeVisitsCount > 0 ? '#EF4444' : '#635BFF'} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="9 18 15 12 9 6" />
                        </svg>
                    </div>
                </div>

                <figure className='hidden xl:block m-0 p-0'>
                    <img src={branding?.banners?.desktop || SVWelcomeDesktop} alt="" className='w-full block' onLoad={handleImageLoad} onError={handleImageLoad} />
                </figure>
                <figure className='hidden sm:block xl:hidden m-0 p-0'>
                    <img src={branding?.banners?.tablet || SVWelcomeImage} alt="" className='w-full block' onLoad={handleImageLoad} onError={handleImageLoad} />
                </figure>
                <figure className='sm:hidden m-0 p-0'>
                    <img src={branding?.banners?.mobile || SVWelcomeMobile} alt="" className='w-full block' onLoad={handleImageLoad} onError={handleImageLoad} />
                </figure>
                <div className=''>
                    <div className='flex items-center justify-center !my-10'>
                        {/* <span className='w-[145px] border-t-2 border-[#696969]'></span> */}
                        <figure className='m-0 h-[62px] sm:h-[90px]  w-[228px]'>
                            <img src={branding?.brand_logo || ramaLogo} alt="" className='h-100 w-100 object-contain' />
                        </figure>
                        <div className='border-r-2 border-[#CFD5DE] h-[80px] sm:h-[100px] !ml-7 !mr-12'></div>
                        <div className=''>
                            {/* <span className='text-xl sm:text-[34px] font-bold italic'>propacity</span> */}
                            <LogoIcon className='sm:w-[200px] sm:h-[90px] w-[130px] h-[62px] ' />
                            {/* <span className='text-xs sm:text-base !mt-3'>Powered By Propacity</span> */}
                        </div>
                        {/* <span className='w-[145px] border-t-2 border-[#696969]'></span> */}
                    </div>
                    <div className='flex items-center justify-center w-full absolute left-0 bottom-6'>
                        <button className='text-white text-lg sm:text-2xl bg-gradient-to-r from-[#6D4DFF] to-[#06F] py-2 sm:py-3.5 w-[95%] sm:w-[396px] rounded-xl flex items-center justify-center'
                            onClick={() => setChannelPartner('2')}
                        >
                            Get Started
                            <span className='!ml-4 '>
                                <RightArrowIcon className='fill-white !w-6' />
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default WelcomePage